import { Switch } from 'antd'
import Button from 'components/Button'
import CustomTag from 'components/CustomTag'
import DragDiv from 'components/DragDiv'
import Drawer from 'components/Drawer'
import EditIcon from 'components/icons/EditIcon'
import PlusIcon from 'components/icons/PlusIcon'
import {
  ActionWrap,
  ContentFlex,
  FleXWrapper,
  SubTextWrapper,
  TextWrapper,
} from 'modules/Drives/DownloadAndUpload/style'
import { FooterFlex } from 'modules/Exp-Candidates/ViewDriveRole/BulkActionDrawer/ScheduleInterviewDrawer/InterviewerDrawer/style'
import React from 'react'
import { IconPointer } from '../BulkActionDrawer/ReqestDocument/Style'
import ConfirmDrawer from './ConfirmDrawer'

const ManageInterviewDrawer = ({
  interviewer,
  setAddRoundDrawer,
  roundConfromDrawer,
  setRoundConfromDrawer,
  sortedItems,
  setSortedItems,
  onEditClick,
  handleDelete,
  getRoleMetrics,
  isEdit,
  setIsEdit,
  onClose,
  handleSubmit,
  getDriveRoleMetrics,
  expcandidatesId,
  getDriveRoleCandidatesList,
  driveId,
  roleId,
  currentPage,
  stage,
  isEditCondition,
  setIsEditCondition,
}) => {
  const onChange = (checked, id) => {
    setSortedItems(prevItems =>
      prevItems.map(item => {
        if (item.id === id) {
          return { ...item, status: checked ? 1 : 0 }
        }
        return item
      })
    )
  }

  const handleRound = async () => {
    setAddRoundDrawer(true)
  }
  const content = () => {
    return isEdit ? (
      <>
        <DragDiv
          headingParam="name"
          descriptionParam="description"
          idParam="id"
          sortedItems={sortedItems}
          setSortedItems={setSortedItems}
          onEditClick={onEditClick}
          disabled={false}
          round="round"
          availableItem={[]}
          handleDelete={handleDelete}
        />
        <div
          style={{
            marginTop: '30px',
            marginBottom: '30px',
            textAlign: 'center',
            color: 'rgba(163, 163, 163, 1)',
          }}
        >
          Note: To skip any round switch off the button
        </div>
        <Button.Secondary
          text="Add Round"
          width="100%"
          icon={<PlusIcon color="#3249D7" />}
          dashed={true}
          onClick={handleRound}
        />
      </>
    ) : (
      <>
        {sortedItems.map((round, index) => (
          <FleXWrapper key={index + round?.name}>
            <ContentFlex key={round.id}>
              <ContentFlex column>
                <div style={{ display: 'flex', gap: '10px' }}>
                  <TextWrapper>{round?.name}</TextWrapper>
                  {round?.isOngoing && (
                    <CustomTag
                      colorType={'orange'}
                      message={'Ongoing'}
                      bordered={false}
                    />
                  )}
                </div>
                <SubTextWrapper
                  dangerouslySetInnerHTML={{ __html: round?.description }}
                ></SubTextWrapper>
              </ContentFlex>
            </ContentFlex>
            <ActionWrap centerVertically>
              <Switch
                defaultChecked={round?.status !== 0}
                onChange={checked => onChange(checked, round?.id)}
              />
            </ActionWrap>
          </FleXWrapper>
        ))}

        <>
          <div
            style={{
              marginTop: '30px',
              marginBottom: '30px',
              textAlign: 'center',
              color: 'rgba(163, 163, 163, 1)',
            }}
          >
            Note: To skip any round switch off the button
          </div>

          <Button.Secondary
            text="Add Round"
            width="100%"
            icon={<PlusIcon color="#3249D7" />}
            dashed={true}
            onClick={handleRound}
          />
        </>
      </>
    )
  }

  const footer = () => {
    return (
      <FooterFlex flexEnd>
        <Button.Secondary
          width="88px"
          height="38px"
          text="Cancel"
          onClick={onClose} // Update onClose to onClick
        />
        <Button.Primary
          width="69px"
          height="38px"
          text="Confirm"
          onClick={handleSubmit}
        />
      </FooterFlex>
    )
  }
  const onClick = () => {
    setIsEdit(!isEdit)
  }

  return (
    <>
      <Drawer
        width="43%"
        title={
          <FooterFlex>
            Manage Interview Rounds
            <IconPointer onClick={onClick}>
              <EditIcon />
            </IconPointer>
          </FooterFlex>
        }
        placement="right"
        visible={interviewer}
        content={content()}
        footer={footer()}
        onClose={onClose}
        closable
      />
      <ConfirmDrawer
        sortedItems={sortedItems}
        setRoundConfromDrawer={setRoundConfromDrawer}
        roundConfromDrawer={roundConfromDrawer}
        getDriveRoleMetrics={getDriveRoleMetrics}
        expcandidatesId={expcandidatesId}
        getDriveRoleCandidatesList={getDriveRoleCandidatesList}
        driveId={driveId}
        roleId={roleId}
        currentPage={currentPage}
        stage={stage}
        getRoleMetrics={getRoleMetrics}
        isEditCondition={isEditCondition}
        setIsEditCondition={setIsEditCondition}
      />
    </>
  )
}

export default ManageInterviewDrawer
